import React from 'react';
import NCBAuth from './NCBAuth';
import { motion } from 'framer-motion';

const AuthPage = ({ mode, onAuthSuccess, setSessionDebug }) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <div className="flex items-center justify-center space-x-3 mb-10">
          <div className="w-12 h-12 bg-black rounded-xl flex items-center justify-center shadow-xl overflow-hidden">
            <img src="https://i.imgur.com/lBD1NkT.png" alt="DeepSearchz" className="w-full h-full object-cover" />
          </div>
          <h1 className="text-3xl font-black text-black tracking-tight">DeepSearchz</h1>
        </div>
        <NCBAuth onAuthSuccess={onAuthSuccess} onAuthError={(err) => console.error(err)} setSessionDebug={setSessionDebug} />
        <p className="mt-8 text-center text-xs text-gray-400 font-medium uppercase tracking-widest">
          Secure • Encrypted • Passwordless
        </p>
      </motion.div>
    </div>
  );
};

export default AuthPage;